var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.routesList),function(routeItem,index){return _c('router-link',{key:index,attrs:{"to":{name: routeItem.route.name, params: {}}/* this is an ambiguous thing prevents route vacancy id to be cached */}},[_vm._v(" \n    "+_vm._s(_vm.$tr(routeItem.labelKey))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }